import { Component } from "@angular/core";
import { ImageViewerService } from "../../services/shared/image-viewer-service";

@Component({
    standalone: false,
    selector: "app-image-viewer",
    templateUrl: "./image-viewer.component.html",
})
export class ImageViewerComponent {
    imageViewerService: ImageViewerService;

    constructor(imageViewerService: ImageViewerService) {
        this.imageViewerService = imageViewerService;
    }
}
